import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonMaxLengthValidatorDirective} from './maxlength.directive';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
	],
	exports: [
		CommonMaxLengthValidatorDirective,
	],
	declarations: [
		CommonMaxLengthValidatorDirective,
	],
	entryComponents: [],
})
export class CommonMaxLengthValidatorModule {}
